import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ms',
  months: [
    'Januari',
    'Februari',
    'Mac',
    'April',
    'Mei',
    'Jun',
    'Julai',
    'Ogos',
    'September',
    'Oktober',
    'November',
    'Disember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
  weekdays: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'],
  weekdaysMin: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
  weekdaysShort: ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd D MMM YYYY h:mm A',
    'llll-Y': 'ddd D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'pg', pm: 'ptg', AM: 'PG', PM: 'PTG' },
  past: {
    y: { other: '%s thn lalu' },
    M: { other: '%s bln lalu' },
    w: { other: '%s mgu lalu' },
    d: { other: '%s hari lalu' },
    h: { other: '%s jam lalu' },
    m: { other: '%s min lalu' },
    s: { other: '%s saat lalu' },
  },
  future: {
    y: { other: 'dalam %s thn' },
    M: { other: 'dlm %s bln' },
    w: { other: 'dlm %s mgu' },
    d: { other: 'dlm %s hari' },
    h: { other: 'dlm %s jam' },
    m: { other: 'dlm %s min' },
    s: { other: 'dlm %s saat' },
  },
  abbr: {
    y: { other: '%sth.' },
    M: { other: '%sb' },
    w: { other: '%sm' },
    d: { other: '%sh' },
    h: { other: '%sj' },
    m: { other: '%smin' },
    s: { other: '%ss' },
  },
  justNow: 'Baru sahaja',
  yesterday: 'Semalam',
  today: 'Hari Ini',
  tomorrow: 'Esok',
  weekStart: 1,
};
const localeName: LocaleName = 'ms';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'pg' : 'PG';
    } else {
      return isLowerCase ? 'ptg' : 'PTG';
    }
  },
};
